<template>
    <div id="chart-container-1" style="height: 100%;width: 100%;"></div>
</template>

<script>
import EmCommonApi from "@/mixin/em/common/api";
import * as echarts from 'echarts';

export default {
    name: "oeeQueryDevice",
    mixins: [EmCommonApi],
    props: {
        autoRefreshFlag: Boolean,   //父组件传递的是否自动刷新标志位
        renderViewFlag: Boolean,     //是否需要渲染组件的标志位
        queryForm: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            chart: {},
            dataValueX: [],
            dataValueY: [],
            option: {},
            fresh: {},
            receiveDate: '',
        }
    },
    watch: {
        //监听queryDate的变化，这个queryDate是父组件传递的参数，利用watch监听再刷新当前子组件
        // queryDate(newValue, oldValue) {
        //     console.log("旧日期：" + oldValue + "父组件传递的新日期：" + newValue)
        //     this.getRemoteData();
        // }
        autoRefreshFlag(newVal) {
            if (newVal) {
                // 当 autoRefreshFlag 变为 true 时，执行刷新操作
                this.getRemoteData();
            }
        },
    },
    created() {

    },
    mounted() {
        window.addEventListener('resize', this.chart.resize, false);
    },
    beforeDestroy() {
        clearInterval(this.fresh);
        window.removeEventListener('resize', this.chart.resize, false)
    },
    methods: {
        getRemoteData() {
            if (this.renderViewFlag === false) {
                //清空：渲染空的echart，跳出不执行下面的正常查询和渲染
                this.dataValueY = [];
                this.loadChart();
                return;
            }
            const _api = `${this.$_emApiMixin_moduleBaseApi("tpmOeeReportTor")}/tpmOeeReportTor/oeeQueryDevice`
            this.$_emApiMixin_post(_api, this.queryForm, false).then(value => {
                let data = value.data;
                //console.log('--------------- 调试：查询单设备OEE 后端返回结果 ----------------')
                //console.log(data)
                this.dataValueY = [];
                this.dataValueY = data[Object.keys(data)]
                this.loadChart()
            })
        },
        formatDateTime(date) {
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0'); // 月份从0开始，需要加1
            const day = String(date.getDate()).padStart(2, '0');

            const hours = String(date.getHours()).padStart(2, '0');
            const minutes = String(date.getMinutes()).padStart(2, '0');
            const seconds = String(date.getSeconds()).padStart(2, '0');

            return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
        },
        loadChart() {
            // 获取屏幕缩放比例动态计算
            let scale = window.devicePixelRatio || 1;
            // 设定原始字体大小（在100%缩放下的字体大小）
            let originalSize = 20; // 适合100%缩放的字体大小
            // 根据缩放比例调整字体大小
            let adjustedSize = originalSize * (1 / scale);

            this.option = {
                backgroundColor: 'rgba(0, 0, 0, 0.2)', // 设置背景色为半透明的黑色
                title: {
                    text: "设备OEE",
                    textStyle: {
                        color: '#ffffff', // 设置图例文字颜色
                        fontSize: adjustedSize,       // 设置 x 轴刻度标签的字体大小
                    }
                },
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'shadow'
                    }
                },
                legend: {
                    data: ['OEE'],
                    textStyle: {
                        color: '#ffffff', // 设置图例文字颜色
                        fontSize: adjustedSize - 2,       // 设置 x 轴刻度标签的字体大小
                    }
                },
                grid: {             //设置图标位置
                    left: '9%',     // 设置左边距为0%
                    right: '9%',    // 可选，设置右边距
                    bottom: '15%',  // 可选，设置底边距
                    top: '15%'      // 可选，设置顶边距
                },
                //color: ['#9900CC', '#3399FF', '#33CC00'], // (全局)设置bar的颜色
                xAxis: {
                    type: 'category',
                    splitLine: {
                        show: true,             // 显示分隔线
                        lineStyle: {
                            color: 'rgba(255, 255, 255, 0.1)'  // 设置分隔线的颜色和透明度
                        }
                    },
                    axisLabel: {
                        textStyle: {
                            color: '#ffffff',   // 设置 x 轴刻度标签的字体颜色
                            fontSize: adjustedSize - 2,       // 设置 x 轴刻度标签的字体大小
                        }
                    },
                    axisLine: {
                        lineStyle: {
                            color: '#ffffff'  // 设置 y 轴轴线颜色
                        }
                    },
                    data: ['OEE', 'A:时间利用率', 'P:性能利用率'],        //<--------【X轴数据】
                    boundaryGap: [0, 0.01]
                },
                yAxis: {
                    type: 'value',
                    splitLine: {
                        show: true,             // 显示分隔线
                        lineStyle: {
                            color: 'rgba(255, 255, 255, 0.1)'  // 设置分隔线的颜色和透明度
                        }
                    },
                    axisLabel: {
                        textStyle: {
                            color: '#ffffff',   // 设置 x 轴刻度标签的字体颜色
                            fontSize: adjustedSize - 2,       // 设置 x 轴刻度标签的字体大小
                        },
                        formatter: '{value}%',    // 自定义标签格式
                    },
                    axisLine: {
                        lineStyle: {
                            color: '#ffffff'  // 设置 y 轴轴线颜色
                        }
                    },
                    //data: [], //test data
                    inverse: false, // 将 y 轴刻度颠倒显示
                    //data: this.dataValueX
                },
                series: [
                    {
                        name: 'OEE',
                        type: 'bar',
                        barWidth: adjustedSize + 50,         // 设置柱子的宽度
                        label: {
                            show: true,             // 显示标签
                            position: 'top',     // 标签位置：inside表示在柱子内部
                            color: 'rgba(255, 255, 255, 1)', // 标签文字颜色
                            fontSize: adjustedSize - 2, // 标签文字大小
                            formatter: '{c}%'        // 标签内容格式化
                        },
                        //data: [48, 80, 60],   //test data
                        data: this.dataValueY,                       //<--------【y轴数据】
                        itemStyle: {
                            color: function (params) {
                                // 自定义颜色数组，根据柱子的索引获取颜色
                                var colorList = ['#9900CC', '#3399FF', '#33CC00'];
                                return colorList[params.dataIndex];
                            }
                        },
                    },
                ]
            }
            this.chart = echarts.init(document.getElementById("chart-container-1"));
            this.chart.setOption(this.option)
            //echart浏览器自动缩放
            // let myChart = this.chart;
            // window.addEventListener('resize', () => {
            //     myChart.resize();
            // })
        }
    }
}
</script>

<style scoped>
#chart-container-1 {
    border: 2px dashed #ffffff; /* 设置虚线边框样式 */
    padding: 10px; /* 可选：添加内边距，使虚线边框更明显 */
    box-sizing: border-box; /* 可选：确保内边距不会增加容器的实际宽度 */
}
</style>
